import React, { createContext, useState, useContext, useEffect } from 'react';
import { validateUser } from '../data/auth';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // Check localStorage for persisted session
        const storedUser = localStorage.getItem('ncrf_user');
        if (storedUser) {
            try {
                setUser(JSON.parse(storedUser));
                setIsAuthenticated(true);
            } catch (e) {
                console.error("Failed to parse stored user", e);
                localStorage.removeItem('ncrf_user');
            }
        }
        setLoading(false);
    }, []);

    const login = (username, password) => {
        const validatedUser = validateUser(username, password);
        if (validatedUser) {
            setUser(validatedUser);
            setIsAuthenticated(true);
            localStorage.setItem('ncrf_user', JSON.stringify(validatedUser));
            return { success: true };
        }
        return { success: false, error: "Invalid username or password" };
    };

    const logout = () => {
        setUser(null);
        setIsAuthenticated(false);
        localStorage.removeItem('ncrf_user');
    };

    return (
        <AuthContext.Provider value={{ user, isAuthenticated, login, logout, loading }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
